export default function dateWithTodayComparator(dateToCompare) {
  const now = new Date();
  const today = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
  const date = new Date(dateToCompare);
  if (date.getTime() < today.getTime()) { return -1; }
  if (date.getTime() === today.getTime()) { return 0; }
  return 1;
}
